const changeTheme = (theme) => ({
    type: "CHANGE_THEME",
    theme,
});

const changeMosaicThemeConfig = (mosaicThemeConfig) => ({
    type: "CHANGE_MOSAIC_THEME_CONFIG",
    mosaicThemeConfig,
});

export const themeChange = (theme) => (dispatch) => {
    dispatch(changeTheme(theme));
};

export const mosaicThemeConfigChange = (mosaicThemeConfig) => (dispatch) => {
    dispatch(changeMosaicThemeConfig(mosaicThemeConfig));
};
